import React, { useState, useEffect } from 'react';
import { Calendar, Filter } from 'lucide-react';
import EventCard from '../components/features/EventCard';
import { eventsService } from '../services/api-service';
import './Events.css';

const Events = () => {
  const [filter, setFilter] = useState('all'); // all, upcoming, past
  const [allEvents, setAllEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    try {
      setLoading(true);
      const all = await eventsService.getAllEvents();
      const upcoming = await eventsService.getUpcomingEvents();
      const past = await eventsService.getPastEvents();
      
      setAllEvents(all);
      setUpcomingEvents(upcoming);
      setPastEvents(past);
    } catch (error) {
      console.error('Error loading events:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFilteredEvents = () => {
    let events;
    switch (filter) {
      case 'upcoming':
        events = upcomingEvents;
        break;
      case 'past':
        events = pastEvents;
        break;
      default:
        events = allEvents;
    }
    
    // Filter out secret events that user doesn't have access to
    // For now, show all events but they'll need code to view details
    // TODO: Check user's promotional codes and filter accordingly
    return events;
  };

  const filteredEvents = getFilteredEvents();

  return (
    <div className="events-page">
      {/* Header */}
      <section className="events-header">
        <div className="container">
          <div className="events-header-content">
            <Calendar size={48} className="events-header-icon" />
            <h1>Events & Celebrations</h1>
            <p>
              Join us for conscious celebrations bringing people together through music, 
              art, and authentic connection. Each event is a reunion of humans where you 
              can be yourself.
            </p>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="events-filters">
        <div className="container">
          <div className="events-filters-content">
            <div className="events-filters-label">
              <Filter size={20} />
              <span>Filter Events:</span>
            </div>
            <div className="events-filters-buttons">
              <button
                className={`events-filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All Events ({allEvents.length})
              </button>
              <button
                className={`events-filter-btn ${filter === 'upcoming' ? 'active' : ''}`}
                onClick={() => setFilter('upcoming')}
              >
                Upcoming ({upcomingEvents.length})
              </button>
              <button
                className={`events-filter-btn ${filter === 'past' ? 'active' : ''}`}
                onClick={() => setFilter('past')}
              >
                Past Events ({pastEvents.length})
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="events-grid-section section">
        <div className="container">
          {loading ? (
            <div className="events-empty">
              <Calendar size={64} className="events-empty-icon" />
              <h3>Loading events...</h3>
            </div>
          ) : filteredEvents.length > 0 ? (
            <div className="events-grid">
              {filteredEvents.map((event) => (
                <EventCard key={event.id} event={event} showArtists={true} />
              ))}
            </div>
          ) : (
            <div className="events-empty">
              <Calendar size={64} className="events-empty-icon" />
              <h3>No events found</h3>
              <p>Check back soon for upcoming celebrations!</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="events-cta section bg-black text-white">
        <div className="container">
          <div className="events-cta-content">
            <h2>Don't Miss Out</h2>
            <p>Subscribe to receive party invitations and stay updated on all our events</p>
            <a href="/subscribe" className="btn btn-orange">
              Subscribe Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;

